import React from 'react'
import { navigate } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import ContentfulLongText from '../../../ContentfulLongText'

export const SectionSide = ({
    item,
    index,
    sideVisibleItems,
    sideVisibleVideoItems,
    sideLoadMoreVideos,
    sideLoadMore
}) => {
    return (
        <div className="side">
            {item.sideTitle && <h4>{item.sideTitle}</h4>}
            <div className="side-lists">
                {item.sideVideos ? item.sideVideos.slice(0, sideVisibleVideoItems[index]).map((sideVideoItem, sideVideoIndex) => (
                    <div key={sideVideoIndex} className="grid col-1-5 gap-10 side-videos">
                        <div className="index">{sideVideoIndex + 1}</div>
                        <div className="content">
                            <a className="block weight-black button-hyperlink cursor-pointer" href={`${sideVideoItem.link}/`}>{sideVideoItem.title}</a>
                            <ContentfulLongText longTextContent={sideVideoItem.content.content}/>
                        </div>
                    </div>
                )):item.sideBlogs.slice(0, sideVisibleItems[index]).map((sideItem, sideIndex) => (
                    <div key={sideIndex} className="grid col-1-5 gap-10">
                        <div className="index">{sideIndex + 1}</div>
                        <div className="content">
                            <a href={`/${sideItem.parentCategory.slugId}/${sideItem.blogPostUrlSlug}/`} className="block mb-5 weight-black   button-hyperlink small cursor-pointer">{sideItem.title}</a>
                            {documentToReactComponents(JSON.parse(sideItem.excerpt.raw))}
                        </div>
                    </div>
                ))}
            </div>
            {item.sideVideos ? sideVisibleVideoItems[index] < item.sideVideos.length && (
                <div className="w-full flex justify-center text-center load-more-container">
                    <button onClick={() => sideLoadMoreVideos(index)} className="relative flex flex-col align-center btn--plain btn-caret">
                        <p className='mb-5'>More</p>
                        <p className='mt-0 mb-0 arrow'></p>
                    </button>
                </div>
            ):sideVisibleItems[index] < item.sideBlogs.length && (
                <div className="w-full flex justify-center text-center load-more-container">
                    <button onClick={() => sideLoadMore(index)} className="relative flex flex-col align-center btn--plain btn-caret">
                        <p className='mb-5'>More</p>
                        <p className='mt-0 mb-0 arrow'></p>
                    </button>
                </div>
            )}
        </div>
    )
}